import type { AppThemeConfig } from "@src/interfaces/theme-config.interface";

export const NCCR_THEME_CONFIG: AppThemeConfig = {
  theme: {
    colors: {},
  },
  assets: {
    header: {
      title: {
        hidden: true,
      },
      logo: {
        src: "/themes/nccr/logo.png",
        alt: "North Carolina Center for Resiliency Logo",
        style: { width: "380px", height: "100%", isMobile: { width: "220px" } },
      },
    },
    icons: {},
  },
  providerGroupId: 35,
  state: "NC",
  departmentIds: [168, 252],
};
